import React, { useState, useEffect } from 'react';
import { Modal, Spin, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { getEvents } from '~/services/hooks/events';
import Pagination from '~/components/Pagination';
import { activityLogsColumns, activityLogsExpanded } from '~/tables/activityLogs';
import errorHandler from '~/Utils/errorHandler';

export default function ActivityLogsModal({ visible, eventId, eventName, onClose }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const fetchActivityLogs = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
        },
      };
      const data = await getEvents(params, `logs/${eventId}`);

      setActivityLogs(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  useEffect(() => {
    if (visible) {
      fetchActivityLogs();
    }
  }, [visible, page, perPage]);

  return (
    <Modal
      title={t('Logs do evento ') + eventName}
      onCancel={onClose}
      open={visible}
      centered
      width="1000px"
      footer={<ModalFooter showOk={false} loading={loading} onCancel={onClose} />}
    >
      <Spin spinning={loading}>
        <Table
          rowKey="id"
          columns={activityLogsColumns()}
          dataSource={activityLogs}
          pagination={false}
          size="small"
          expandable={{
            expandedRowRender: (record) => activityLogsExpanded(record),
            expandedRowKeys,
            onExpand: handleExpand,
          }}
        />
        <Pagination
          onChange={(value) => {
            setPage(value);
          }}
          meta={meta}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </Spin>
    </Modal>
  );
}
